import {
    Fragment,
    useState
} from "react";
import {
    TouchableOpacity,
    View
} from "react-native";
import type RejectReasonModalProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    TextAreaInput,
    Button,
    Dialog,
    Modal,
    Text
} from "ncore-ui-kit";
import {
    XIcon
} from "lucide-react-native";

const RejectReasonModal = ({
    isLoading = false,
    isVisible,
    onConfirm,
    onClose,
    title
}: RejectReasonModalProps) => {
    const {
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const [
        reason,
        setReason
    ] = useState<string>("");

    const [
        isConfirmDialogVisible,
        setIsConfirmDialogVisible
    ] = useState<boolean>(false);

    const handleConfirm = () => {
        setIsConfirmDialogVisible(false);
        onConfirm(reason);
        setReason("");
    };

    const handleClose = () => {
        setIsConfirmDialogVisible(false);
        setReason("");
        onClose();
    };

    return <Fragment>
        <Modal
            portalName="modal-system"
            id="reject-reason-modal"
            onClosed={handleClose}
            isActive={isVisible}
        >
            <View
                style={[
                    stylesheet.container,
                    {
                        backgroundColor: colors.project.brandWhite,
                        borderRadius: radiuses.lg,
                        padding: spaces.spacingXl,
                        gap: spaces.spacingLg
                    }
                ]}
            >
                <View
                    style={stylesheet.headerContainer}
                >
                    <Text
                        customColor={colors.content.text.high}
                        variant="titleMediumSize"
                    >
                        {title || localize("requests-reject-reason-title")}
                    </Text>
                    <TouchableOpacity
                        style={stylesheet.closeButton}
                        onPress={handleClose}
                    >
                        <XIcon
                            color={colors.content.icon.mid}
                            size={24}
                        />
                    </TouchableOpacity>
                </View>
                <View
                    style={stylesheet.inputContainer}
                >
                    <TextAreaInput
                        key={`reject-reason-input-${isVisible ? "visible" : "hidden"}`}
                        placeholder={localize("requests-reject-reason-placeholder")}
                        title={localize("requests-reject-reason-title")}
                        customColor={colors.project.inputBackground}
                        onChangeText={(val) => setReason(val)}
                        isUpdateOnRealtime={true}
                        spreadBehaviour="stretch"
                        minHeight={100}
                        value={reason}
                    />
                </View>
                <View
                    style={[
                        stylesheet.footerContainer,
                        {
                            gap: spaces.spacingMd
                        }
                    ]}
                >
                    <Button
                        title={localize("notifications-detail-close")}
                        customTextColor={colors.project.brandWhite}
                        customBorderColor="secondaryButton"
                        customColor="secondaryButton"
                        spreadBehaviour="free"
                        onPress={handleClose}
                        variant="filled"
                    />
                    <Button
                        onPress={() => setIsConfirmDialogVisible(true)}
                        title={localize("requests-reject-confirm-btn")}
                        spreadBehaviour="free"
                        isLoading={isLoading}
                        variant="filled"
                        type="danger"
                    />
                </View>
            </View>
        </Modal>
        <Dialog
            onOverlayPress={() => setIsConfirmDialogVisible(false)}
            primaryButtonProps={{
                title: localize("requests-reject-confirm-title"),
                onPress: handleConfirm
            }}
            secondaryButtonProps={{
                onPress: () => setIsConfirmDialogVisible(false),
                title: localize("cancel")
            }}
            content={localize("requests-reject-confirm-desc")}
            onClosed={() => setIsConfirmDialogVisible(false)}
            isVisible={isConfirmDialogVisible}
            variant="yes-no"
        />
    </Fragment>;
};
export default RejectReasonModal;
